var map = {
	"./ACCOUNTING/iconequip.svg": 44804,
	"./AUTO/iconequip.svg": 10402,
	"./AUTOCOMP/iconequip.svg": 85475,
	"./AUTOWASH/iconequip.svg": 27483,
	"./BARBERSHOP/iconequip.svg": 50597,
	"./BIKE/iconequip.svg": 20608,
	"./BOAT/iconequip.svg": 62509,
	"./BRICO/iconequip.svg": 14322,
	"./CLASS/iconequip.svg": 87465,
	"./DEFAULT/iconequip.svg": 34394,
	"./DEFAULTPATIENTSVERTICAL/iconequip.svg": 11130,
	"./ELECTROMECH/iconequip.svg": 81038,
	"./ELEVATOR/iconequip.svg": 83217,
	"./EQUESTRIAN/iconequip.svg": 46616,
	"./FARRIER/iconequip.svg": 9868,
	"./GARDEN/iconequip.svg": 82348,
	"./GRAPHVINYL/iconequip.svg": 19067,
	"./HEALTH/iconequip.svg": 88257,
	"./HOMECLEAN/iconequip.svg": 59989,
	"./HOMEREPAIR/iconequip.svg": 58213,
	"./HOTEL/iconequip.svg": 64603,
	"./MARKETINGIMAGE/iconequip.svg": 69884,
	"./METALWORK/iconequip.svg": 13199,
	"./MOTO/iconequip.svg": 4092,
	"./NUTRITION/iconequip.svg": 3417,
	"./PHYSIO/iconequip.svg": 78295,
	"./POOL/iconequip.svg": 76893,
	"./TECH/iconequip.svg": 51327,
	"./TELECOMS/iconequip.svg": 39769,
	"./TRUCK/iconequip.svg": 33216,
	"./VET/iconequip.svg": 12256,
	"./WELLBEING/iconequip.svg": 99588,
	"./WOODWORK/iconequip.svg": 10155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73355;